import { createWebHistory, createRouter } from "vue-router";
import { canActivate } from '@/services/auth-guard.service';
import MainLayout from "@/layouts/MainLayout.vue";
import NoMenuLayout from "@/layouts/NoMenuLayout.vue";

const routes = [
  {
    path: "/",
    component: NoMenuLayout,
    children: [
      { path: "", redirect: "/main" },
      { path: "init", component: () => import("@/views/Init.vue") },
      { path: "callback", component: () => import("@/views/Callback.vue") }
    ]
  },
  {
    path: "/main",
    component: MainLayout,
    children: [
      { path: "", name: "Home", component: () => import('@/views/Home.vue') },
      {
        path: "pages",
        component: "",
        children: [
          { path: "", name: "Pages", component: () => import('@/views/Pages/Manage.vue') },
          { path: "new", name: "New Page", component: () => import('@/views/Pages/New.vue') },
          { path: ":id", name: "Edit Page", component: () => import("@/views/Pages/Edit.vue") }
        ]
      },
      {
        path: "blogs",
        component: "",
        children: [
          { path: "", name: "Blogs", component: () => import('@/views/Blogs/Manage.vue') },
          { path: "new", name: "New Blog", component: () => import('@/views/Blogs/New.vue') },
          { path: ":id", name: "Edit Blog", component: () => import("@/views/Blogs/Edit.vue") }
        ]
      },
      {
        path: "categories",
        component: "",
        children: [
          { path: "", name: "Categories", component: () => import('@/views/Categories/Manage.vue') },
          { path: "new", name: "New Category", component: () => import('@/views/Categories/New.vue') },
          { path: ":id", name: "Edit Category", component: () => import("@/views/Categories/Edit.vue") }
        ]
      },
      { path: "settings", name: "Settings", component: () => import('@/views/Settings/Main.vue') },
      {
        path: "webhooks",
        component: "",
        children: [
          { path: "", name: "Webhooks", component: () => import('@/views/Webhooks/Manage.vue') },
          { path: "new", name: "New Webhook", component: () => import('@/views/Webhooks/New.vue') },
          { path: ":id", name: "Edit Webhook", component: () => import("@/views/Webhooks/Edit.vue") }
        ]
      }
    ],
    beforeEnter: (to, from, next) => {
      next(canActivate())
    }
  },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // Browser back/forward buttons
        if (savedPosition) {
            return savedPosition
        }

        // Scroll to top on route change
        return { top: 0 }
    }
});

router.afterEach((to) => {
  document.title = to.name ?? "CMS"
});

export default router;